import { useState } from 'react';
import EditDesign from './Design/EditDesign';
import { useTranslation } from 'react-i18next';

interface DefaultDesignSideBarType {
	productId?: string;
	selectedObject?: any;
	loading?: boolean;
	canvas?: any;
	product: any;
	renderAll: () => void;
	addDesign?: ({ design }: { design: any }) => void;
	functions: {
		onAddText?: ({ text, fontFamily }: { text: string; fontFamily?: string }) => void;
		fitText?: (obj: any) => void;
		addSymbol?: ({ symbol }: { symbol: string }) => void;
		addImage?: (image: string) => void;
		alignText?: (type: string) => void;
		removeObject?: (object: any) => void;
		removeSelectedObject?: () => void;
		setDisabledButton: (value: boolean) => void;
	};
	chosenDesign?: any;
	resetChosenDesign?: () => void;
	updateTextVersion: any;
	engravingColor: string | null;
}
function DefaultDesignSideBar({ product, canvas, productId = '', chosenDesign, loading, functions, engravingColor }: DefaultDesignSideBarType) {
	const { setDisabledButton, fitText } = functions;
	const { t } = useTranslation();

	// const objects = (canvas as any)?.getObjects();
	return (
		<div className="flex flex-col h-full ">
			{/* <div className="border-b-[#D4C4F6] border-b border-solid flex flex-col pb-[30px] gap-[16px] mb-[30px] ">
				<p className="font-bold text-[20px]">Description</p>
				<p className="text-[14px] font-normal">
					<Markdown>{product?.description}</Markdown>
				</p>
			</div> */}
			<div className=" overflow-y-auto overflow-x-hidden max-h-[590px] h-full">
				<div className="flex flex-row  items-center ">
					<p className="flex-1 font-bold text-[20px]">{t('Options')}:</p>
				</div>

				{!loading && <EditDesign design={chosenDesign} canvas={canvas} setDisabledButton={setDisabledButton} hideHeader engravingColor={engravingColor} fitText={fitText} />}
			</div>
		</div>
	);
}

export default DefaultDesignSideBar;
